// extracted by mini-css-extract-plugin
export default {"popover":"InfoItem_popover__UladZ","button":"InfoItem_button__zA0Nd","panel":"InfoItem_panel__GKqtA"};